module.exports = __webpack_public_path__ + "c82ade18d2c87620d4257040008625b9.jpg";